export default function(e, ownerThis) {
  const htmlObj = e.currentTarget;
  if(htmlObj.value === '') {
    const prefix = htmlObj.id.slice(0, htmlObj.id.lastIndexOf('_') + 1),
          languages = ['tw', 'en', 'cn', 'ja'],
          len = languages.length;

    let tempValue = '';
    
    for(let i = 0; i < len; i++) {
      tempValue = ownerThis.state[prefix + languages[i]];
      if( tempValue || tempValue === 0) {
        ownerThis.setState({
          [htmlObj.id]: tempValue
        }, () => {htmlObj.select();});
        break;
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/commonJS/autoFill.js